import React from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import { TranslateButton } from 'src/Components/Buttons/TranslateButton'

import { useReviewTranslation } from './useReviewTranslation'

const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const CommentText = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  word-break: break-word;
`

interface ReviewCommentSectionProps {
  comment?: string
}

export const ReviewCommentSection: React.FC<ReviewCommentSectionProps> = ({
  comment,
}) => {
  const {
    shouldShowButton: showTranslateButton,
    isTranslated,
    isLoading: isTranslating,
    targetLanguageName,
    displayText,
    onToggle: onToggleTranslation,
  } = useReviewTranslation(comment)

  if (!comment) {
    return null
  }

  return (
    <>
      <CommentWrapper>
        <CommentText>{displayText}</CommentText>
      </CommentWrapper>
      {showTranslateButton && (
        <TranslateButton
          translated={isTranslated}
          loading={isTranslating}
          label={`Translate to ${targetLanguageName}`}
          onClick={onToggleTranslation}
          data-testid='translate-review-button'
        />
      )}
    </>
  )
}
